export default {"src":"/_next/static/media/iran.8e735784.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};